var _circle, _mask, _g, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _path2, _path3, _path4, _path5, _path6, _path7, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _path8, _circle107;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongTerm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 64,
    r: 49.5,
    fill: "#DEF7EC",
    stroke: "#18191B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "longTerm_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 14,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 64,
    r: 49.5,
    fill: "#DEF7EC",
    stroke: "#18191B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#longTerm_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 71.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 71.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 69.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 69.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 110.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 73.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 73.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 67.5 104.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 67.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 73.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 71.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 69.5 108.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 73.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 65.5 106.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 110.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 110.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 110.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 110.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 73.5 110.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 112.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 75.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 77.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 81.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 101.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 98.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 100.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 102.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 95.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 88.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 83.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 97.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 88.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 101.5 88.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 89.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 101.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 88.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 107.5 88.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 101.5 92.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 101.5 90.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 88.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 93.5 96.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 91.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 87.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 85.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 79.5 94.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 99.5 86.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 84.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 82.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 80.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 78.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 101.5 86.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 84.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 82.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 107.5 80.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 107.5 78.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 103.5 86.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 107.5 84.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 109.5 84.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 107.5 82.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 109.5 82.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 109.5 80.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 109.5 78.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 109.5 76.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 107.5 86.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 105.5 86.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 109.5 84.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 110.5 82.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 111.5 80.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 111.5 78.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    transform: "matrix(0 -1 -1 0 111.5 76.5)",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 93.505V55H30v38.505h13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 93.505H43V55H30v38.505h6.5zm0 0V103",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 30.714V62h13V30.714H88z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 30.714H88V62h13V30.714h-6.5zm0 0V23",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 94.323V41.339h13v52.984H59z",
    fill: "#84E1BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 41.339H72v52.984h-6.5m0-52.984H59v52.984h6.5m0-52.984V29m0 65.323V112.5",
    stroke: "#000"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 64,
    r: 49.5,
    stroke: "#18191B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.353 24.794a.5.5 0 001 0v-2.147h2.147a.5.5 0 000-1h-2.147V19.5a.5.5 0 00-1 0v2.147h-2.147a.5.5 0 000 1h2.147v2.147z",
    fill: "#18191B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 110.294,
    r: 1.5,
    transform: "rotate(-180 111 110.294)",
    stroke: "#18191B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 101.5,
    r: 22,
    fill: "#84E1BC",
    stroke: "#18191B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 46.205 87.523)",
    fill: "#18191B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 88.886)",
    fill: "#18191B",
    r: 0.341
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 90.25)",
    fill: "#18191B",
    r: 0.341
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 91.614)",
    fill: "#18191B",
    r: 0.341
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 92.977)",
    fill: "#18191B",
    r: 0.341
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 94.34)",
    fill: "#18191B",
    r: 0.341
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 95.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 97.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 46.205 98.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 44.84 87.523)",
    fill: "#18191B",
    r: 0.341
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 44.84 88.886)",
    fill: "#18191B",
    r: 0.341
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 44.84 90.25)",
    fill: "#18191B",
    r: 0.341
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 44.84 91.614)",
    fill: "#18191B",
    r: 0.341
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 44.84 92.977)",
    fill: "#18191B",
    r: 0.341
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 44.84 94.34)",
    fill: "#18191B"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 44.84 95.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 44.84 97.068)",
    fill: "#18191B"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 44.84 98.432)",
    fill: "#18191B"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 43.477 87.523)",
    fill: "#18191B",
    r: 0.341
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 43.477 88.886)",
    fill: "#18191B",
    r: 0.341
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 43.477 90.25)",
    fill: "#18191B",
    r: 0.341
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 43.477 90.25)",
    fill: "#18191B",
    r: 0.341
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 43.477 91.614)",
    fill: "#18191B"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 42.114 87.523)",
    fill: "#18191B",
    r: 0.341
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 42.114 88.886)",
    fill: "#18191B"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 42.114 90.25)",
    fill: "#18191B",
    r: 0.341
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 40.75 87.523)",
    fill: "#18191B",
    r: 0.341
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 39.386 87.523)",
    fill: "#18191B",
    r: 0.341
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 40.75 86.16)",
    fill: "#18191B",
    r: 0.341
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 40.75 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 40.75 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 42.114 86.16)",
    fill: "#18191B",
    r: 0.341
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 42.114 84.796)",
    fill: "#18191B"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 42.114 83.432)",
    fill: "#18191B"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 43.477 86.16)",
    fill: "#18191B"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 43.477 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 44.84 86.16)",
    fill: "#18191B"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 39.386 86.16)",
    fill: "#18191B",
    r: 0.341
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 39.386 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 38.022 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 39.386 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 39.386 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 38.022 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 38.022 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 40.75 88.886)",
    fill: "#18191B"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 38.022 86.16)",
    fill: "#18191B",
    r: 0.341
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 36.66 86.16)",
    fill: "#18191B"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 35.295 86.16)",
    fill: "#18191B",
    r: 0.341
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 33.932 86.16)",
    fill: "#18191B",
    r: 0.341
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 36.66 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 35.295 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 33.932 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 32.568 84.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 36.66 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 35.295 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 33.932 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 32.568 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 31.204 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 29.84 82.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 36.66 80.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 35.295 80.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 33.932 80.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 32.568 80.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 31.204 80.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 29.84 80.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 36.66 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 35.295 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 33.932 83.432)",
    fill: "#18191B"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 32.568 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 31.204 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 29.84 83.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 90.25)",
    fill: "#18191B",
    r: 0.341
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 88.886)",
    fill: "#18191B",
    r: 0.341
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 47.568 91.614)",
    fill: "#18191B"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 91.614)",
    fill: "#18191B",
    r: 0.341
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 92.977)",
    fill: "#18191B",
    r: 0.341
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 94.34)",
    fill: "#18191B",
    r: 0.341
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 95.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 97.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 98.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 99.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.568 101.159)",
    fill: "#18191B",
    r: 0.341
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 92.977)",
    fill: "#18191B",
    r: 0.341
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 94.34)",
    fill: "#18191B",
    r: 0.341
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 94.34)",
    fill: "#18191B",
    r: 0.341
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 95.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 95.705)",
    fill: "#18191B",
    r: 0.341
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 97.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 97.068)",
    fill: "#18191B",
    r: 0.341
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 98.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 48.932 99.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 48.932 101.159)",
    fill: "#18191B"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 98.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 99.796)",
    fill: "#18191B",
    r: 0.341
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 101.159)",
    fill: "#18191B",
    r: 0.341
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 102.523)",
    fill: "#18191B",
    r: 0.341
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 50.295 103.886)",
    fill: "#18191B",
    r: 0.341
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 88.972L29.703 101.5 22 88.972l7.703-1.79L37 88.972z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 88.972l7.703 12.528L37 88.972m-15 0l7.703 2.147L37 88.972m-15 0l7.703-1.79L37 88.972",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.909 95.758L29.7 101.5l-3.61-5.742 3.61-1.076 3.209 1.076z",
    fill: "#FACA15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.09 95.758l3.61 5.742 3.209-5.742m-6.818 0l3.61 1.077 3.208-1.077m-6.818 0l3.61-1.076 3.208 1.076",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.703 101.5L37 113.697l-7.297 3.485L22 113.697l7.703-12.197z",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.703 109l-5.676 2.291L22 113.909l7.703 3.273L37 113.909l-2.027-2.945-5.27-1.964z",
    fill: "#FACA15",
    stroke: "#000",
    strokeLinejoin: "round"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    r: 0.341,
    transform: "matrix(-1 0 0 1 32.568 112.068)",
    fill: "#18191B"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 29.841 103.886)",
    fill: "#18191B",
    r: 0.341
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 31.887 113.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 25.068 112.75)",
    fill: "#18191B",
    r: 0.341
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 28.477 107.295)",
    fill: "#18191B",
    r: 0.341
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 33.25 113.432)",
    fill: "#18191B",
    r: 0.341
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 31.204 105.932)",
    fill: "#18191B",
    r: 0.341
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.84 91.273v25.909",
    stroke: "#000"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 80,
    r: 3.5,
    transform: "rotate(-180 7 80)",
    stroke: "#18191B"
  })));
}
export default SvgLongTerm;